
const getters = {
    language: state => state.app.language,
    curUser: state => state.curUser
}
export default getters
